import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BillingModalService } from '@app/core/services/billing/billing/billing-modal/billing-modal.service';
import { VideoDetailsService } from '@app/core/services/video-details.service';
import { WithdrawalProductType } from '@generated/generatedEntities';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-lcc',
  templateUrl: './lcc.component.html',
  styleUrls: ['./lcc.component.scss'],
})
export class LccComponent implements OnInit {
  private router = inject(Router);
  private videoDetailService = inject(VideoDetailsService);
  private translocoService = inject(TranslocoService);
  @Input() isAuthenticated!: boolean;
  @Input() hasLccCosts!: boolean;
  @Output() openBillingModal: EventEmitter<WithdrawalProductType> = new EventEmitter();

  isGerman = false;

  ngOnInit(): void {
    this.isGerman = this.translocoService.getActiveLang() === 'de-CH';
    this.translocoService.langChanges$.subscribe((lang) => {
      this.isGerman = lang === 'de-CH';
    });
  }

  goToLccForm() {
    this.router.navigate(['/lcc-form/input']);
  }

  openModal() {
    this.openBillingModal.emit('LCC_PACKAGE');
  }

  hasVideo(): boolean {
    return this.videoDetailService.hasVideo('lcc');
  }

  openVideoDialog(): void {
    this.videoDetailService.openVideoDialog('lcc');
  }
}
